import { createSlice, PayloadAction } from '@reduxjs/toolkit'

// Define a type for the slice state
interface EarningRuleState {
  page: number
}

// Define the initial state using that type
const initialState: EarningRuleState = {
  page: 0,
}

export const earningRuleSlice = createSlice({
  name: 'earning-rules',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    setCurrentPage: (state, action: PayloadAction<number>) => {
        state.page = action.payload
    },
  }
})

export const { setCurrentPage } = earningRuleSlice.actions

export default earningRuleSlice.reducer